const Login = () => import( './views/Login.vue');
const NotFound = () => import( './views/404.vue');
const Safeguard = () => import( './views/500.vue');
const Home = () => import( './views/Home.vue');
const Main = () => import( './views/Main.vue');
const UserPage = () => import( './views/authorityManage/user.vue');
const UserEditPage = () => import( './views/authorityManage/editUser.vue');
const DataDicPage = () => import( './views/dataDicManage/dataDic.vue');
const MenuPage = () => import( './views/authorityManage/menu.vue');
const MenuEditPage = () => import( './views/authorityManage/editMenu.vue');
const RolePage = () => import( './views/authorityManage/role.vue');
const RoleEditPage = () => import( './views/authorityManage/editRole.vue');
const YKHE006Page = () => import('./views/ykhe006/list.vue');
const YKHE006EditPage = () => import('./views/ykhe006/edit.vue');
const YKHE008Page = () => import('./views/ykhe008/list.vue');
const YKHE008EditPage = () => import('./views/ykhe008/edit.vue');
const ListTestPage = () =>import('./views/ykhe008/testlist');
const EDITTestPage = () =>import('./views/ykhe008/testedit');
const YKHE009Page = () => import('./views/ykhe009/list.vue');
const YKHE009EditPage = () => import('./views/ykhe009/edit.vue');
const YKHE010Page = () => import('./views/ykhe010/list.vue');
const YKHE010EditPage = () => import('./views/ykhe010/edit.vue');
const YKHE011Page = () => import('./views/ykhe011/list.vue');
const YKHE011EditPage = () => import('./views/ykhe011/edit.vue');
const YKHE012Page = () => import('./views/ykhe012/list.vue');
const YKHE012EditPage = () => import('./views/ykhe012/edit.vue');
const YKHE013Page = () => import('./views/ykhe013/list.vue');
const YKHE013DetailPage = () => import('./views/ykhe013/detail.vue');
const YKHE015Page = () => import('./views/ykhe015/list.vue');
const YKHE015EditPage = () => import('./views/ykhe015/edit.vue');
const YKHE016Page = () => import('./views/ykhe016/list.vue');
const YKHE016EditPage = () => import('./views/ykhe016/edit.vue');
const YKHE017Page = () => import('./views/ykhe017/list.vue');
const YKHE017EditPage = () => import('./views/ykhe017/edit.vue');
const YKHE018Page = () => import('./views/ykhe018/list.vue');
const YKHE018EditPage = () => import('./views/ykhe018/edit.vue');
const PDFPAGE = () => import('./views/PDFPage.vue');
const VIDEO = () => import('./views/videofile.vue');
const MAINPAGE = () => import('./views/ykhe008/mainhe008.vue')
const MAIN006PAGE = () => import('./views/ykhe006/mainhe006.vue');
const GRADE =() =>import('./views/reportfrom/grade');
const CLASSINFO =() =>import('./views/reportfrom/classinfo');
const ADRESS =() =>import('./views/reportfrom/adress');
const JOBS =() =>import('./views/reportfrom/jobs');
const UNIT =() =>import('./views/reportfrom/unit');
const UNITANDJOB =() =>import('./views/reportfrom/unitandjobs');
const YKHE009MORELIST = () => import('./views/ykhe009/moreselectlist');

const NEWTEST = () => import('./views/NewTest');

import ForgetPwdPage from './views/ForgetPwd.vue';


let routes = [

  {
    path: '/login',
    component: Login,
    name: ''
  },
  {
    path: '/404',
    component: NotFound,
    name: ''
  },
  {
    path: '/500',
    component: Safeguard,
    name: ''
  },
  {
    path: '/forgetpwd',
    component: ForgetPwdPage,//忘记密码
    name: ''
  },
  {
    path: '/',
    component: Home,
    children:[
      { path: '/', component: YKHE008Page, name: '首页'},
      { path: '/user', component: UserPage, name: '用户管理'},
      { path: '/edituser', component: UserEditPage, name: '添加编辑用户'},
      { path: '/role', component: RolePage, name: '角色管理'},
      { path: '/editrole', component: RoleEditPage, name: '添加编辑角色'},
      { path: '/menu', component: MenuPage, name: '菜单管理'},
      { path: '/editmenu', component: MenuEditPage, name: '添加编辑菜单'},
      { path: '/datadic', component: DataDicPage, name: '数据字典维护'},
      { path: '/ykhe006',component: YKHE006Page, name: '培训学院信息管理'},
      { path: '/editykhe006',component: YKHE006EditPage, name: '学院信息维护'},
      { path: '/ykhe008',component: YKHE008Page, name: '培训班级管理'},
      { path: '/editykhe008',component: YKHE008EditPage, name: '班级信息维护'},
      { path: '/testlist',component:ListTestPage,name:'班级试题信息'},
      { path: '/testedit',component:EDITTestPage,name:'班级试题信息维护'},
      { path: '/ykhe009',component: YKHE009Page, name: '学员信息管理'},
      { path: '/editykhe009',component: YKHE009EditPage, name: '学员信息维护'},
      { path: '/ykhe010',component: YKHE010Page, name: '发票管理'},
      { path: '/editykhe010',component: YKHE010EditPage, name: '发票信息维护'},
      { path: '/ykhe011',component: YKHE011Page, name: '课件管理'},
      { path: '/editykhe011',component: YKHE011EditPage, name: '课件信息维护'},
      { path: '/ykhe012',component: YKHE012Page, name: '二级公司管理'},
      { path: '/editykhe012',component: YKHE012EditPage, name: '二级公司信息维护'},
      { path: '/ykhe013',component: YKHE013Page, name: '学习记录'},
      { path: '/detailykhe013',component: YKHE013DetailPage, name: '学习记录详情'},
      { path: '/ykhe015',component: YKHE015Page, name: '班级测试管理'},
      { path: '/editykhe015',component: YKHE015EditPage, name: '班级测试信息维护'},
      { path: '/ykhe016',component: YKHE016Page, name: '班级学员管理'},
      { path: '/editykhe016',component: YKHE016EditPage, name: '班级学员信息维护'},
      { path: '/ykhe017',component: YKHE017Page, name: '班级课程管理'},
      { path: '/editykhe017',component: YKHE017EditPage, name: '班级课程信息维护'},
      { path: '/ykhe018',component: YKHE018Page, name: '发布消息管理'},
      { path: '/editykhe018',component: YKHE018EditPage, name: '发布消息维护'},
      { path: '/videofile',component: VIDEO, name: '班级课程信息维护'},
      { path: '/PDFPage',component: PDFPAGE, name: 'pdf加载页'},
      { path: '/mainPage',component: MAINPAGE, name: '班级主页'},
      {path:'/main006Page',component:MAIN006PAGE,name:'基本信息管理'},
      { path: '/grade',component:GRADE,name:'成绩统计报表'},
      { path: '/classinfo',component:CLASSINFO,name:'创办班级报表'},
      { path: '/adress',component:ADRESS,name:'地点分类统计报表'},
      { path: '/jobs',component:JOBS,name:'岗位分类统计报表'},
      { path: '/unit',component:UNIT,name:'单位分类统计报表'},
      { path: '/unitandjob',component:UNITANDJOB,name:'单位分岗位统计报表'},
      { path: '/009morelist',component:YKHE009MORELIST,name:'批量添加列表'},

      { path: '/newtest',component:NEWTEST,name:'111111'}

    ]
  }
];
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js